module.exports = __webpack_public_path__ + "static/img/688.63875996.png";